// CareWay — collection filter behavior. Real Shopify filtering (GET params),
// no fake filter buttons.

class FilterForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    if (this.form) {
      this.form.addEventListener('change', () => this.submit());
    }
  }

  submit() {
    const params = new URLSearchParams(new FormData(this.form));
    window.location.search = params.toString();
  }
}
customElements.define('filter-form', FilterForm);
